import * as services from './services';
import * as actionCreators from './actions';

export const removeLineFromInterpretation = (lineRefId) => dispatch => {
    dispatch(actionCreators.removeLineFromInterpretation(lineRefId));
    return services.removeLineFromInterpretation(lineRefId)
        .then(data => dispatch(actionCreators.removeLineFromInterpretationSuccess(data.data)))
        .catch(e => dispatch(actionCreators.removeLineFromInterpretationFail(e)));
}
